// Tu archivo principal
import "./plugins/contentful-paint";
import "./plugins/hamburger";

document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelector(".export-index")) {
		import("./plugins/export-index")
			.then((module) => {
				if (module && module.exportIndex) {
					module.exportIndex();
				} else {
					console.error("exportIndex function not found in export-index module.");
				}
			})
			.catch((err) => {
				console.error("Error loading export-index module:", err);
			});
	} else {
		console.log("No se exportan las funciones.");
	}

	if (jQuery("#category-selector-button")) {
		import("./utils/category-selector");
	}
});
